import { flyAndSailRouteTranslations, routeTranslations, sailAndFlyRouteTranslations } from "@/config/global.strings";
import { DirectionEnum, ModeOfTravelEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";

const useBookingSummary = () => {
	const bookingStore = useBookingStore();

	const getIconNames = (direction: DirectionEnum) => {
        if(bookingStore.getBooking.modeOfTravel === ModeOfTravelEnum.FlyAndSail) {
            return direction === DirectionEnum.Outward ? 'vessel-aircraft' : 'vessel-ship';
        }
		else if(bookingStore.getBooking.modeOfTravel === ModeOfTravelEnum.SailAndFly) {
            return direction === DirectionEnum.Return ? 'vessel-aircraft' : 'vessel-ship';
        }
        else {
            return bookingStore.getBooking.modeOfTravel === ModeOfTravelEnum.Scillonian ? 'vessel-ship' : 'vessel-aircraft';
        }       
    }

	const getRouteTranslations = (route: string, modeOfTravel: ModeOfTravelEnum) => {
		const routeTranslationList = modeOfTravel === ModeOfTravelEnum.FlyAndSail ? 
					flyAndSailRouteTranslations : modeOfTravel === ModeOfTravelEnum.SailAndFly ? 
					sailAndFlyRouteTranslations : 
					routeTranslations; 

		return routeTranslationList.find(t => t.code === route)?.name;
	}

	return { getIconNames, getRouteTranslations }
}

export default useBookingSummary;